export const role = {
    ADMIN: '425A0876-E43B-44ED-A453-61A0ED1BFEF7',
    READ_ONLY: 'E4D6B89C-3AEE-4AAE-8E66-A7D90E23096A',
    MANAGER: 'BB46FC6D-DC50-49F2-A77D-33328BCB1358'
}
